import { render, staticRenderFns } from "./NewChatHistoryContactItem.vue?vue&type=template&id=e0a9a146"
import script from "./NewChatHistoryContactItem.vue?vue&type=script&lang=js"
export * from "./NewChatHistoryContactItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports